<template>
  <div v-if="emplacement && finChargement">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('detailEmplacement.title') + emplacement.code }}
                  <b-tag v-if="!emplacement.actif"
                        type="has-background-subMenu"
                        class="has-text-white mgl-5px">
                  {{$t('detailEmplacement.archive')}}
                </b-tag>
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button"
                :class="{'button-access-no-permission' : !checkPermissions(emplacementPerm.maj)}"
                @click="checkPermissions(emplacementPerm.maj) ?
                  $router.push({ name: 'l.gabed.emplacement' }) : showPopUp()">
                {{ $t('general.button.return')}}
              </button>
              <b-dropdown class="button is-bottom-left has-text-left">
                <div slot="trigger" class="right">
                  <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                  <b-icon icon="chevron-down" class="has-text-default"></b-icon>
                </div>
                <b-dropdown-item class="pdl-20px">
                  <p class="has-text-icon-more is-size-7">
                    {{$t('detailEmplacement.titleAccesRapide')}}
                  </p>
                </b-dropdown-item>
                <b-dropdown-item class="is-paddingless"
                                v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                  <router-link-blank :to="{ name: accesRapide.name,
                                        params: accesRapide.params}"
                                    class="pdt-5px pdb-5px"
                                    classMessage="has-text-default is-size-6 is-block
                                      mgl-20px mgr-20px"
                                    classComposant="noTextDecoration"
                                    :message="accesRapide.libelle">
                  </router-link-blank>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         class="mgt-20px"
                        :error="error"
                        :messagesChampsVide="messagesChampsVide"
                        :champsVide="champsVide"
                        :title="titleError"
                        :withEmplyFields="true"
                        @close="error = $event"/>
    <div class="mgt-20px">
      <div class="column is-paddingless is-3">
        <b-field>
          <b-input :placeholder="$t('listeCommandes.actions.search')"
                   type="search"
                   icon="magnify"
                   class="inputSearch">
          </b-input>
          <p class="control">
            <button class="button is-primary">
              {{ $t('listeCommandes.actions.search')}}
            </button>
          </p>
        </b-field>
      </div>
      <div class="columns is-justify-content-end" v-if="elementInactif > 0">
        <div class="column is-narrow is-align-self-center">
          <div class="lien has-text-right">
            <span class="is-cursor-pointer" @click="displayInactif = !displayInactif">
              {{ displayInactif
                ? $t('detailEmplacement.actions.displayInactif')
                : $t('detailEmplacement.actions.displayActif')
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="columns mgt-10px">
        <span class="column is-2"> {{ $t('detailEmplacement.emplacement') }}</span>
        <span class="column is-3"> {{ $t('detailEmplacement.dispoPublicitaire') }}</span>
        <span class="column"> {{ $t('detailEmplacement.faces') }}</span>
      </div>
      <div class="columns">
        <div class="column is-2 emplacement">
          <div class="emplacementComposant">
            <div class="shadow box is-marginless is-cursor-pointer emplacementZindex">
              <div class="columns is-marginless">
                <div class="column is-paddingless" @click="switchDetailEmplacement()">
                  <p>{{ $t(getTypeEmplacement) }}
                    <span class="is-size-7" v-if="emplacement.emplacementAdresse">
                      {{ emplacement.emplacementAdresse.domaine }}
                    </span>
                  </p>
                  <router-link-blank v-if="moduleEmplacementClientActive && emplacement.clientId"
                    :message="emplacement.client.nomCommercial"
                    :to="{ name: 'c.bodac.clients/contacts-client',
                      params: { id: emplacement.clientId }}">
                  </router-link-blank>
                  <span class="has-text-weight-bold">
                    {{ importedFunction.adressFullStringGetter(emplacement.adresseCadastrale) }}
                  </span>
                  <br/>
                </div>
                <div class="column is-paddingless is-narrow">
                  <b-dropdown position="is-bottom-left" aria-role="list">
                    <a slot="trigger">
                      <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                    </a>
                    <b-dropdown-item
                      @click="affichageDemande(constantes.EMPLACEMENTS, emplacement)"
                      :class="{ 'button-access-no-permission' :
                        !checkPermissions(permDemande.lecture)}">
                      <p class="is-default is-size-6">
                        {{$t('demandeLogistique.patrimoine.see')}}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="emplacement.actif"
                      @click="createDemande(constantes.EMPLACEMENTS, emplacement)"
                      :class="{ 'button-access-no-permission' :
                        !checkPermissions(permDemande.maj)}">
                      <p class="is-default is-size-6">
                        {{$t('demandeLogistique.patrimoine.create')}}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="accessToLogistiqueTechnique && emplacement.actif">
                      <router-link-blank
                        :to="{ name: 'm.logistique.ordre_travail-techAdd',
                        params: { patrimoineId: emplacement.id,
                        typePatrimoine: constantes.EMPLACEMENTS }}"
                        :class="{'button-access-no-permission':
                          !checkPermissions(constantes.ORDRE_TRAVAIL.maj)}"
                        :message="$t('detailEmplacement.actions.otTech')"
                        classMessage="is-default is-size-6"
                        classComposant="noTextDecoration"/>
                    </b-dropdown-item>
                    <b-dropdown-item @click="checkPermissions(emplacementPerm.supprimer)
                      ? showPopUpPrevention(constantes.EMPLACEMENTS, emplacement,
                        constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                      : showPopUp()"
                      >
                      <p class="is-default is-size-6">
                        {{ $t('general.button.'
                      + (emplacement.actif ? 'archiver' : 'desarchiver')) }} </p>
                    </b-dropdown-item>
                    <b-dropdown-item @click="checkPermissions(emplacementPerm.supprimer)
                      ? showPopUpPrevention(constantes.EMPLACEMENTS, emplacement,
                        constantes.ACTION_TYPE_SUPPRESSION)
                      : showPopUp()">
                        <p class="is-default is-size-6">
                          {{ $t('general.button.delete')}}
                        </p>
                      </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="shadow box is-marginless is-cursor-pointer mgt-20px
              has-background-light">
              <div class="columns is-marginless">
                <div class="column is-paddingless has-background-light">
                  <p class="has-text-weight-bold is-size-5 mgb-10px">
                    {{$t('detailEmplacement.legende')}}
                  </p>
                  <p v-for="etat in allEtat" :key="etat.value"  class="mgb-5px">
                    <span class="is-size-7">
                      <b-icon icon="checkbox-blank-circle" size="is-small"
                              :type="getCouleur(etat.value)"
                      ></b-icon>
                      {{$t(etat.libelle)}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="separationPointillee"></span>
        <div class="column is-10">
          <div v-for="(dispositif, index) in dispositifs" :key="dispositif.id">
            <div class="shadow box has-background-primary is-paddingless is-marginless dispositif"
              :class="dispositif.actif ? '' : 'pdb-10px'">
              <div class="columns mgt-5px is-marginless">
              <span class="has-text-white has-text-weight-bold column mgl-8px ellipsis
                is-cursor-pointer"
                  @click="$router.push({
                        name: 'c.gabed.emplacement-detailDispositif',
                        params: {
                          idDispositif: dispositif.id
                        }})"
                >
                <span class="has-text-weight-bold">
                  <b-tooltip
                  :label="getLibellePuce(dispositif).libelle"
                  :type="getLibellePuce(dispositif).couleur"
                  position="is-right"
                  append-to-body
                  >
                    <b-icon icon="checkbox-blank-circle" custom-size="is-size-7"
                            class="width-100percent"
                      :type="getLibellePuce(dispositif).couleur"
                    ></b-icon>
                  </b-tooltip>
                  {{dispositif.code}}
                </span>
                <p class="is-size-7 ellipsis">
                  {{ dispositif.dispositifType === null ? ''
                    : dispositif.dispositifType.libelle }}
                </p>
              </span>
                <div class="column is-narrow">
                  <b-dropdown position="is-bottom-left" aria-role="list">
                    <a slot="trigger">
                      <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                    </a>
                    <b-dropdown-item
                      @click="affichageDemande(constantes.DISPOSITIF, dispositif)"
                      :class="{ 'button-access-no-permission' :
                        !checkPermissions(permDemande.lecture)}">
                      <p class="is-default is-size-6">
                        {{$t('demandeLogistique.patrimoine.see')}}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="dispositif.actif"
                      @click="createDemande(constantes.DISPOSITIF, dispositif)"
                      :class="{ 'button-access-no-permission' :
                        !checkPermissions(permDemande.maj)}">
                      <p class="is-default is-size-6">
                        {{$t('demandeLogistique.patrimoine.create')}}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="accessToLogistiqueTechnique && dispositif.actif">
                      <router-link-blank
                        :to="{ name: 'm.logistique.ordre_travail-techAdd',
                        params: { patrimoineId: dispositif.id,
                        typePatrimoine: constantes.DISPOSITIF }}"
                        :class="{'button-access-no-permission':
                          !checkPermissions(constantes.ORDRE_TRAVAIL.maj)}"
                        :message="$t('detailEmplacement.actions.otTech')"
                        classMessage="is-default is-size-6"
                        classComposant="noTextDecoration"/>
                    </b-dropdown-item>
                    <b-dropdown-item :class="{ 'button-access-no-permission' :
                      !checkPermissions(emplacementPerm.maj)}"
                     @click="checkPermissions(emplacementPerm.maj) ?
                      $router.push({
                        name: 'm.gabed.emplacement-dispositifPublicitaireEdition',
                        params: {
                          idDispositif: dispositif.id
                      }}) : showPopUp()">
                      <p class="is-default is-size-6">
                        {{ $t('general.button.edit')}}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item  v-if="dispositif.actif"
                      @click="checkPermissions(emplacementPerm.supprimer)
                      ? showPopUpPrevention(constantes.DISPOSITIF, dispositif,
                        constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                      : showPopUp()">
                      <p class="is-default is-size-6">
                        {{ $t('general.button.archiver') }}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item v-else-if="!dispositif.actif && emplacement.actif"
                      @click="checkPermissions(emplacementPerm.supprimer)
                      ? showPopUpPrevention(constantes.DISPOSITIF, dispositif,
                        constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                      : showPopUp()">
                      <p class="is-default is-size-6">
                        {{ $t('general.button.desarchiver') }}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="checkPermissions(emplacementPerm.maj)
                      ? showPopUpPrevention(constantes.DISPOSITIF, dispositif,
                        constantes.ACTION_TYPE_DUPLIQUER)
                      : showPopUp()">
                      <p class="is-default is-size-6">
                        {{ $t('general.button.dupliquer') }}
                      </p>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <p class="is-default is-size-6"
                        @click="checkPermissions(emplacementPerm.supprimer)
                          ? showPopUpPrevention(constantes.DISPOSITIF, dispositif,
                            constantes.ACTION_TYPE_SUPPRESSION)
                          : showPopUp()">
                        {{ $t('general.button.delete')}}
                      </p>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <div v-for="materiel in dispositif.materiels" :key="materiel.id"
                   class="columns ensembleMaterielFaces">
                <div class="column is-narrow"
                     :class="{'mgb-10px': dispositif.materiels.length > 1 }">
                  <div class="is-marginless materiel shadow box"
                       :class="{'containNoFace' : materiel.faces.length === 0 &&
                       !materiel.numerique}">
                    <div class="columns is-gapless">
                      <div class="column columns is-multiline is-marginless is-paddingless">
                        <span class="column is-11 is-paddingless is-size-7 is-cursor-pointer
                        max-width-165 ellipsis"
                              @click="$router.push({
                                name: 'c.gabed.emplacement-detailMateriel',
                                params: {
                                  idMateriel: materiel.id,
                                }
                              })"
                        >
                          <b-tooltip
                            :label="getLibellePuce(materiel).libelle"
                            :type="getLibellePuce(materiel).couleur"
                            position="is-right"
                            append-to-body>
                            <b-icon icon="checkbox-blank-circle" custom-size="is-size-7"
                                    class="width-100percent"
                              :type="getLibellePuce(materiel).couleur"
                            ></b-icon>
                          </b-tooltip>
                          <span class="has-text-weight-bold">
                            {{materiel.code}}
                          </span>
                        </span>
                        <div class="column is-1 is-paddingless">
                          <b-dropdown position="is-bottom-left" aria-role="list">
                            <a slot="trigger">
                              <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                            </a>
                            <b-dropdown-item
                              @click="affichageDemande(constantes.MATERIEL, materiel)"
                              :class="{ 'button-access-no-permission' :
                                !checkPermissions(permDemande.lecture)}">
                              <p class="is-default is-size-6">
                                {{$t('demandeLogistique.patrimoine.see')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="materiel.actif"
                              @click="createDemande(constantes.MATERIEL, materiel)"
                              :class="{ 'button-access-no-permission' :
                                !checkPermissions(permDemande.maj)}">
                              <p class="is-default is-size-6">
                                {{$t('demandeLogistique.patrimoine.create')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="accessToLogistiqueTechnique && materiel.actif">
                              <router-link-blank
                                :to="{ name: 'm.logistique.ordre_travail-techAdd',
                                params: { patrimoineId: materiel.id,
                                typePatrimoine: constantes.MATERIEL }}"
                                :class="{'button-access-no-permission':
                                  !checkPermissions(constantes.ORDRE_TRAVAIL.maj)}"
                                :message="$t('detailEmplacement.actions.otTech')"
                                classMessage="is-default is-size-6"
                                classComposant="noTextDecoration"/>
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkPermissions(emplacementPerm.maj) ?
                                  $router.push({ name: 'm.gabed.emplacement-materielEdition',
                                  params: {
                                    idMateriel: materiel.id
                                  }}) :
                                  showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.edit')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="materiel.actif"
                              @click="checkPermissions(emplacementPerm.supprimer)
                              ? showPopUpPrevention(constantes.MATERIEL, materiel,
                                constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                              : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.archiver') }}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="!materiel.actif && dispositif.actif"
                              @click="checkPermissions(emplacementPerm.supprimer)
                              ? showPopUpPrevention(constantes.MATERIEL, materiel,
                                constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                              : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.desarchiver') }}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item>
                              <p class="is-default is-size-6"
                              @click="checkPermissions(emplacementPerm.maj)
                              ? showPopUpPrevention(constantes.MATERIEL, materiel,
                                constantes.ACTION_TYPE_DUPLIQUER)
                              : showPopUp()">
                                {{ $t('general.button.dupliquer')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item>
                              <p class="is-default is-size-6"
                              @click="checkPermissions(emplacementPerm.supprimer)
                              ? showPopUpPrevention(constantes.MATERIEL, materiel,
                                constantes.ACTION_TYPE_SUPPRESSION)
                              : showPopUp()">
                                {{ $t('general.button.delete')}}
                              </p>
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                        <div class="column is-10 is-paddingless" v-if="!materiel.numerique">
                          <div class="ellipsis max-width-165">
                            <span class="has-text-weight-bold is-size-6 ellipsis">
                              {{ materiel.type === null ? '' : materiel.type.libelle }}
                            </span>
                            <span class="is-size-7">{{materiel.disposition}}</span>
                            <br>
                            <span class="is-size-7">{{ materiel.format.libelle }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <span class="has-text-default is-size-7">
                            {{ $t('detailEmplacement.timeLoop',
                              {value: materiel.informationsNumeriques.timeSpot})}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column columns is-multiline is-paddingless is-marginless"
                  v-if="!materiel.numerique">
                  <div class="column is-narrow face"
                      v-for="(face, $index) in materiel.faces" :key="face.id"
                      :class="{'beforePlus': $index +1 === materiel.faces.length,'before5Face':
                    ($index + 1) % 5 === 0,'before3Face': ($index + 1) % 3 === 0,}">
                    <div class="shadow box faceComposant"
                      :class="{'faceAvecDemande':
                        face.demandesLogistique && face.demandesLogistique.length >0 }">
                      <div class="columns is-multiline is-marginless is-paddingless">
                        <div class="column is-10 is-multiline is-marginless is-paddingless">
                          <div class="is-size-7 column is-12 ellipsis
                            is-marginless is-paddingless is-cursor-pointer"
                            @click="$router.push({
                              name: 'c.gabed.emplacement-face',
                              params: {
                                idFace: face.id,
                              }
                            })">
                            <b-tooltip
                              :label="getLibellePuce(face).libelle"
                              :type="getLibellePuce(face).couleur"
                              position="is-right"
                              append-to-body>
                              <b-icon icon="checkbox-blank-circle" custom-size="is-size-7"
                                      class="width-100percent"
                                :type="getLibellePuce(face).couleur"
                              ></b-icon>
                            </b-tooltip>
                            <span class="has-text-weight-bold">
                              {{face.code}}
                            </span>
                          </div>
                          <span class="is-size-8 has-text-weight-bold
                            has-text-primary column is-12 is-marginless is-paddingless ellipsis">
                              {{ face.faceMotifNonCom ? face.faceMotifNonCom.libelle : ''}}
                          </span>
                        </div>
                        <div
                          v-if="face.demandesLogistique && face.demandesLogistique.length > 0"
                          class="column is-1 is-paddingless">
                          <b-icon icon="format-paint"
                            size="is-small"
                            type="is-warning">
                          </b-icon>
                        </div>
                        <div class="column is-1 mgt-5px is-paddingless">
                          <b-dropdown position="is-bottom-left" aria-role="list">
                            <a slot="trigger">
                              <b-icon icon="dots-vertical" class="has-text-secondary-icon"></b-icon>
                            </a>
                            <b-dropdown-item @click="affichageDemande(constantes.FACE, face)"
                            :class="{ 'button-access-no-permission' :
                              !checkPermissions(permDemande.lecture)}">
                              <p class="is-default is-size-6">
                                {{$t('demandeLogistique.patrimoine.see')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="face.actif"
                            @click="createDemande(constantes.FACE, face)"
                            :class="{ 'button-access-no-permission' :
                              !checkPermissions(permDemande.maj)}">
                              <p class="is-default is-size-6">
                                {{$t('demandeLogistique.patrimoine.create')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="accessToLogistiqueTechnique && face.actif">
                              <router-link-blank
                                :to="{ name: 'm.logistique.ordre_travail-techAdd',
                                params: { patrimoineId: face.id,
                                typePatrimoine: constantes.FACE }}"
                                :class="{'button-access-no-permission':
                                  !checkPermissions(constantes.ORDRE_TRAVAIL.maj)}"
                                :message="$t('detailEmplacement.actions.otTech')"
                                classMessage="is-default is-size-6"
                                classComposant="noTextDecoration"/>
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkPermissions(emplacementPerm.maj) ?
                              $router.push({ name: 'm.gabed.emplacement-faceEdition',
                              params: {
                                idMateriel: materiel.id,
                                idFace: face.id
                              }}) : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.edit')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkPermissions(emplacementPerm.maj) ?
                            checkUpdateProduitFace(face) : showPopUp()"
                                             v-if="face.actif">
                              <p class="is-default is-size-6">
                                {{ $t('detailEmplacement.actions.remplacer')}}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-if="face.actif"
                              @click="checkPermissions(emplacementPerm.supprimer)
                              ? showPopUpPrevention(constantes.FACE, face,
                                constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                              : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.archiver') }}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item v-else-if="!face.actif && materiel.actif"
                              @click="checkPermissions(emplacementPerm.supprimer)
                              ? showPopUpPrevention(constantes.FACE, face,
                                constantes.ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE)
                              : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.desarchiver') }}
                              </p>
                            </b-dropdown-item>
                            <b-dropdown-item @click="checkPermissions(emplacementPerm.supprimer)
                            ? showPopUpPrevention(constantes.FACE, face,
                              constantes.ACTION_TYPE_SUPPRESSION)
                            : showPopUp()">
                              <p class="is-default is-size-6">
                                {{ $t('general.button.delete')}}
                              </p>
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-narrow" v-if="materiel.actif">
                    <a @click="checkPermissions(emplacementPerm.maj) ?
                    $router.push({ name: 'm.gabed.emplacement-faceEdition',
                    params: {
                      idMateriel: materiel.id,
                      idFace: 1
                    }}) : showPopUp()">
                      <b-icon icon="plus-circle"
                              size="is-medium"
                              class="has-text-secondary-icon mgt-5">
                      </b-icon>
                    </a>
                  </div>
                </div>
                <div v-else
                  class="column columns is-multiline is-paddingless is-marginless">
                  <div class="column is-2-fullhd is-4-tablet face">
                    <div class="shadow box faceComposant">
                      <div class="columns is-multiline is-marginless is-paddingless">
                        <div class="column is-multiline is-marginless is-paddingless">
                          <span class="is-size-7 column
                            is-marginless is-paddingless has-text-default">
                            {{ $t('detailEmplacement.spots')}}
                            <span class="has-text-weight-bold">
                              {{ $t('detailEmplacement.numberSpot',
                              {value: materiel.informationsNumeriques.spotNumber})}}
                            </span>
                          </span>
                          <span class="is-size-7
                            column is-12 is-marginless is-paddingless has-text-default">
                            {{ $t('detailEmplacement.timeSpot',
                              {value: materiel.informationsNumeriques.timeSpot})}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a class="has-text-white button is-primary is-fullwidth"
                :class="{ 'button-access-no-permission': !checkPermissions(emplacementPerm.maj)}"
               @click="checkPermissions(emplacementPerm.maj) ?
            $router.push({ name: 'm.gabed.emplacement-ajoutMateriel',
            params: { idDispositifExistant: dispositif.id } }) :
            showPopUp()"
            v-if="dispositif.actif">
                {{ $t('detailEmplacement.addMateriel')}}
              </a>
            </div>
            <div class="ligne-between-dispositif"
                 v-if="((index + 1) !== allDispositif.length && !emplacement.actif)
                 || emplacement.actif">
            </div>
          </div>
          <div class="shadow box has-background-primary is-paddingless is-marginless dispositif"
            v-if="emplacement.actif">
            <a class="card-footer has-text-white button is-primary is-fullwidth"
             :class="{ 'button-access-no-permission': !checkPermissions(emplacementPerm.maj)}"
               @click="checkPermissions(emplacementPerm.maj) ?
                 $router.push({name: 'm.gabed.emplacement-dispositifPublicitaire',
                              params: { id: emplacement.id }})
                 :showPopUp()">
              {{ $t('detailEmplacement.ajoutDispositif')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showPopUpDemande" has-modal-card class="modal">
        <creationDemande
          :agenceId="emplacement.agenceId"
          :face="faceDemande"
          :materiel="materielDemande"
          :dispositif="dispositifDemande"
          :emplacement="emplacementDemande">
        </creationDemande>
    </b-modal>
    <b-modal v-model="showPopUpListeDemandes" has-modal-card class="modal">
        <demandes
          :face="faceDemande"
          :materiel="materielDemande"
          :dispositif="dispositifDemande"
          :emplacement="emplacementDemande">
        </demandes>
    </b-modal>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal" @close="closePopUpPrevention">
      <pop-up-prevention
        v-if="patrimoineToArchive"
        @no="closePopUpPrevention"
        @yes="actionPopUpPrevention"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="messageHeader"
        :mess-footer="messageFooter">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { get, archiver as archiverEmplacement, supprimer as supprimerEmplacement } from '@/api/gabed/emplacement/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { DEMANDE, ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  getAll,
  archiver as archiverDispositif,
  dupliquerAsync as dupliquerAsyncDispositif,
  supprimer as supprimerDispositif,
} from '@/api/gabed/dispositif/index';
import { getAll as getAllDemandeLogistique } from '@/api/logistique/demandeLogistique/index';
import {
  EMPLACEMENT as EMPLACEMENTS, FACE, MATERIEL, DISPOSITIF,
  COULEUR_DEMONTE, COULEUR_AMONTER_ADEMONTER, COULEUR_MONTE, COULEUR_ARCHIVE,
  COULEUR_ENCOURS_MONTAGE_DEMONTAGE, COULEUR_ENCOURS_DE_FABRICATION, COULEUR_FABRIQUE,
  PARKING, ADRESSE, CENTRE_COMMERCIAL, TYPE_EMPLACEMENT as LIST_EMPLACEMENT, LIGNE_BUS,
  ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE, ACTION_TYPE_SUPPRESSION, CLIENT, ACTION_TYPE_DUPLIQUER,
} from '@/configuration/gabed/emplacement/emplacementConf';
import dispositifSort from '@/services/gabed/dispositif/dispositifSort';
import inProgress from '@/services/general/inProgress';
import genererElementMaterielNumerique from '@/services/gabed/materiel/genererElementMaterielNumerique';
import {
  ETAT_DISPOSITIF_PUBLICITAIRE, ALL_ETAT_DISPOSITIF_PUBLICITAIRE,
  AMONTE, DEMONTE, ADEMONTE, MONTE, ENCOURSDEFABRICATION, FABRIQUE,
} from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import formatDate from '@/services/general/formatDate';
import creationDemande from '@/components/gabed/face/p_editionDemande';
import demandes from '@/components/gabed/face/p_demandes';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { deleteFace, checkUtilisationFaceAsync, archiver } from '@/api/gabed/face';
import validationDeleteFace from '@/services/gabed/face/validationDeleteFace';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import {
  INTERVENTION_TYPE_AFFICHAGE, INTERVENTION_TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationFace from '@/services/gabed/face/validationFace';
import {
  archiver as archiverMateriel,
  supprimer as supprimerMateriel,
  dupliquer as dupliquerMateriel,
} from '@/api/gabed/materiel';
import validationSuppressionMateriel from '@/services/gabed/materiel/validationSuppression';
import validationSuppressionEmplacement from '@/services/gabed/emplacement/validationSuppression';
import validationDispositif from '@/services/gabed/dispositif/validation';
import validationEmplacement from '@/services/gabed/emplacement/validationEmplacement';
import validationMateriel from '@/services/gabed/materiel/validation';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  TYPE_DISPOSITIF, TYPE_EMPLACEMENT, TYPE_MATERIEL, TYPE_FACE,
} from '@/configuration/logistique/tournee/tourneeConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import validationSuppressionDispositif from '@/services/gabed/dispositif/validationSuppression';
import cloneDeep from 'lodash/cloneDeep';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const Face = createNamespacedHelpers('face');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'c_detailEmplacement',
  data() {
    return {
      finChargement: false,
      emplacementPerm: EMPLACEMENT,
      permDemande: DEMANDE,
      importedFunction: {
        adressFullStringGetter,
      },
      emplacement: null,
      allDispositif: null,
      faceDemande: null,
      materielDemande: null,
      dispositifDemande: null,
      emplacementDemande: null,
      showPopUpDemande: false,
      showPopUpListeDemandes: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      titleError: null,
      openPopUpPrevention: false,
      actionTypePopUpPrevention: null,
      patrimoineToArchive: null,
      errorPopUp: false,
      messagesErreurPopUp: [],
      typePatrimoine: '',
      messageFooter: '',
      messageHeader: '',
      displayInactif: true,
      constantes: {
        EMPLACEMENTS,
        DISPOSITIF,
        MATERIEL,
        FACE,
        ORDRE_TRAVAIL,
        TYPE_EMPLACEMENT,
        TYPE_MATERIEL,
        TYPE_DISPOSITIF,
        TYPE_FACE,
        ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE,
        ACTION_TYPE_SUPPRESSION,
        ACTION_TYPE_DUPLIQUER,
      },
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    creationDemande,
    demandes,
    errorMsgComponent,
    popUpPrevention,
    routerLinkBlank,
  },
  computed: {
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    accessToLogistiqueTechnique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    getTypeEmplacement() {
      return LIST_EMPLACEMENT.find((typeEmplacement) => {
        return typeEmplacement.name === this.emplacement.type;
      }).libelle;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        { title: this.$i18n.t('detailEmplacement.titleWithoutN'), route: '', isActive: true },
      ];
    },
    genererAllAccesRapide() {
      const accesRapides = [];
      if (this.emplacement) {
        accesRapides.push(
          { name: 'l.baux.contrat-by-materiel', params: { typePatrimoine: EMPLACEMENTS, patrimoineId: this.emplacement.id }, libelle: this.$t('detailEmplacement.voirBaux') },
        );
      }
      return accesRapides;
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    allEtat() {
      const etats = (this.moduleEmplacementClientActive
        || this.emplacement.clientId) ? ALL_ETAT_DISPOSITIF_PUBLICITAIRE
        : ETAT_DISPOSITIF_PUBLICITAIRE;
      return etats.sort((a, b) => {
        return a.libelle.localeCompare(b.libelle);
      });
    },
    dispositifs() {
      if (this.displayInactif) {
        return cloneDeep(this.allDispositif)
          .filter(d => d.actif === this.displayInactif)
          .map(d => {
            d.materiels = d.materiels.filter(m => m.actif === this.displayInactif);
            d.materiels.map(m => {
              m.faces = m.faces.filter(f => f.actif === this.displayInactif);
              return m;
            });
            return d;
          });
      }
      return this.allDispositif;
    },
    elementInactif() {
      const inactifDispositif = this.allDispositif.filter(d => d.actif === false).length;
      const intactifMateriel = this.allDispositif.reduce((acc, d) => {
        return acc + d.materiels.filter(m => m.actif === false).length;
      }, 0);
      const inactifFaces = this.allDispositif.reduce((acc, d) => {
        return acc + d.materiels.reduce((accM, m) => {
          return accM + m.faces.filter(f => f.actif === false).length;
        }, 0);
      }, 0);
      return intactifMateriel + inactifFaces + inactifDispositif;
    },
  },
  methods: {
    ...Face.mapActions({
      setInfoFace: 'setInfoFace',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    closePopUpPrevention() {
      this.openPopUpPrevention = false;
      this.patrimoineToArchive = null;
      this.typePatrimoine = '';
      this.actionTypePopUpPrevention = null;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    setMessagePreventionSuppression() {
      switch (this.typePatrimoine) {
        case FACE:
          this.messageHeader = this.$i18n.t('detailFace.supprimerFace', { code: this.patrimoineToArchive.code });
          break;
        case MATERIEL:
          this.messageHeader = this.$t('materiel.supprimer.titre');
          this.messageFooter = this.$t('materiel.supprimer.sousTitre');
          break;
        case DISPOSITIF:
          this.messageHeader = this.$t('dispositifPublicitaire.supprimer.titre');
          this.messageFooter = this.$t('dispositifPublicitaire.supprimer.sousTitre');
          break;
        case EMPLACEMENTS:
          this.messageHeader = this.$t('emplacement.supprimer.titre');
          this.messageFooter = this.$t('emplacement.supprimer.sousTitre');
          break;
        default:
          break;
      }
    },
    setMessagePreventionAchivageDesarchivage() {
      switch (this.typePatrimoine) {
        case EMPLACEMENTS:
          this.messageHeader = this.$i18n.t('detailEmplacement.archivageDesarchiver.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
          this.messageFooter = this.$i18n.t(('detailEmplacement.infoArchivageDesarchivage.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage')));
          break;
        case DISPOSITIF:
          this.messageHeader = this.$i18n.t('dispositifPublicitaire.archivageDesarchiver.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
          this.messageFooter = this.$i18n.t(('dispositifPublicitaire.infoArchivageDesarchivage.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage')));
          break;
        case MATERIEL:
          this.messageHeader = this.$i18n.t('materiel.archivageDesarchiver.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
          this.messageFooter = this.$i18n.t('materiel.infoArchivageDesarchivage.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
          break;
        case FACE:
          this.messageHeader = this.$i18n.t('detailFace.archivageDesarchiver.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
          break;
        default:
          break;
      }
    },
    setMessagePreventionDupliquer() {
      switch (this.typePatrimoine) {
        case DISPOSITIF:
          this.messageHeader = this.$i18n.t('dispositifPublicitaire.popUpPreventionCopy.message');
          break;
        case MATERIEL:
          this.messageHeader = this.$i18n.t('materiel.dupliquer.message');
          break;
        default:
          break;
      }
    },
    showPopUpPrevention(type, patrimoineToArchive, actionType) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.openPopUpPrevention = true;
      this.messageFooter = '';
      this.messageHeader = '';
      this.patrimoineToArchive = patrimoineToArchive;
      this.typePatrimoine = type;
      this.actionTypePopUpPrevention = actionType;
      switch (this.actionTypePopUpPrevention) {
        case ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE:
          this.setMessagePreventionAchivageDesarchivage();
          break;
        case ACTION_TYPE_SUPPRESSION:
          this.setMessagePreventionSuppression();
          break;
        case ACTION_TYPE_DUPLIQUER:
          this.setMessagePreventionDupliquer();
          break;
        default:
          break;
      }
    },
    async actionPopUpPrevention() {
      switch (this.actionTypePopUpPrevention) {
        case ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE:
          await this.archiverPatrimoine();
          break;
        case ACTION_TYPE_SUPPRESSION:
          await this.supprimerPatrimoine();
          break;
        case ACTION_TYPE_DUPLIQUER:
          await this.dupliquerPatrimoine();
          break;
        default:
          break;
      }
    },
    async archiverPatrimoine() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      let messageSuccess = '';
      try {
        switch (this.typePatrimoine) {
          case EMPLACEMENTS:
            messageSuccess = this.$i18n.t('detailEmplacement.messages.success.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
            await archiverEmplacement(this.patrimoineToArchive.id, this.patrimoineToArchive.actif);
            break;
          case DISPOSITIF:
            messageSuccess = this.$i18n.t('dispositifPublicitaire.messages.success.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
            await archiverDispositif(this.patrimoineToArchive.id, this.patrimoineToArchive.actif);
            break;
          case MATERIEL:
            messageSuccess = this.$i18n.t('materiel.messages.success.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
            await archiverMateriel(this.patrimoineToArchive.id, this.patrimoineToArchive.actif);
            break;
          case FACE:
            messageSuccess = this.$i18n.t('detailFace.messages.success.'
            + (this.patrimoineToArchive.actif ? 'archivage' : 'desarchivage'));
            await archiver(this.patrimoineToArchive.id, this.patrimoineToArchive.actif);
            break;
          default:
            break;
        }
        messageSucces(messageSuccess);
        this.closePopUpPrevention();
        loadingComponent.close();
        await this.load();
      } catch (e) {
        if (e.response.data.error) {
          switch (this.typePatrimoine) {
            case EMPLACEMENTS:
              validationEmplacement(e.response, this.messagesErreurPopUp);
              break;
            case DISPOSITIF:
              validationDispositif(e.response, this.messagesErreurPopUp);
              break;
            case MATERIEL:
              validationMateriel(e.response, this.messagesErreurPopUp);
              break;
            case FACE:
              validationFace(e.response, this.messagesErreurPopUp);
              break;
            default:
              break;
          }
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async supprimerPatrimoine() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      let messageSuccess = '';
      try {
        switch (this.typePatrimoine) {
          case FACE:
            messageSuccess = this.$t('listeFace.messages.success.faceDeleted', { code: this.patrimoineToArchive.code });
            await deleteFace(this.patrimoineToArchive.id);
            break;
          case MATERIEL:
            messageSuccess = this.$t('materiel.messages.success.supprimer');
            await supprimerMateriel(this.patrimoineToArchive.id);
            break;
          case DISPOSITIF:
            messageSuccess = this.$t('dispositifPublicitaire.messages.success.supprimer');
            await supprimerDispositif(this.patrimoineToArchive.id);
            break;
          case EMPLACEMENTS:
            messageSuccess = this.$t('emplacement.messages.success.suppression');
            await supprimerEmplacement(this.patrimoineToArchive.id);
            break;
          default:
            break;
        }
        messageSucces(messageSuccess);
        if (this.typePatrimoine === EMPLACEMENTS) {
          this.closePopUpPrevention();
          loadingComponent.close();
          this.$router.push({
            name: 'l.gabed.emplacement',
            params: { activeTab: 'emplacement' },
          });
        } else {
          this.closePopUpPrevention();
          loadingComponent.close();
          await this.load();
        }
      } catch (e) {
        if (e.response.data.error) {
          switch (this.typePatrimoine) {
            case FACE:
              validationDeleteFace(e.response, this.messagesErreurPopUp);
              break;
            case MATERIEL:
              validationSuppressionMateriel(e.response, this.messagesErreurPopUp);
              break;
            case DISPOSITIF:
              validationSuppressionDispositif(e.response, this.messagesErreurPopUp);
              break;
            case EMPLACEMENTS:
              validationSuppressionEmplacement(e.response, this.messagesErreurPopUp);
              break;
            default:
              break;
          }
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async dupliquerPatrimoine() {
      const loadingComponent = this.$buefy.loading.open();
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      let messageSuccess = '';
      try {
        switch (this.typePatrimoine) {
          case MATERIEL:
            messageSuccess = this.$t('materiel.messages.success.dupliquer');
            await dupliquerMateriel(this.patrimoineToArchive.id);
            break;
          case DISPOSITIF:
            messageSuccess = this.$t('dispositifPublicitaire.popUpPreventionCopy.success');
            await dupliquerAsyncDispositif(this.patrimoineToArchive.id);
            break;
          default:
            break;
        }
        messageSucces(messageSuccess);
        this.closePopUpPrevention();
        await this.load();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messagesErreurPopUp,
            this.messagesChampsVide, translate);
          validationPatrimoine(e.response, this.messagesErreurPopUp);
          switch (this.typePatrimoine) {
            case MATERIEL:
              validationMateriel(e.response, this.messagesErreurPopUp);
              break;
            default:
              break;
          }
          this.errorPopUp = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    changeRoute(routeName, idEmplacement) {
      if (routeName) {
        return this.$router.push({
          name: routeName,
          params: {
            id: idEmplacement,
          },
        });
      } return this.inProgress();
    },
    switchDetailEmplacement() {
      let routeName;
      switch (this.emplacement.type) {
        case ADRESSE:
          routeName = 'c.gabed.emplacement-adresse';
          break;
        case PARKING:
          routeName = 'c.gabed.emplacement-parking';
          break;
        case CENTRE_COMMERCIAL:
          routeName = 'c.gabed.emplacement-centreCommercial';
          break;
        case LIGNE_BUS:
          routeName = 'c.gabed.emplacement-ligneBus';
          break;
        case CLIENT:
          routeName = 'c.gabed.emplacement-client';
          break;
        default:
          routeName = null;
      }
      this.changeRoute(routeName, this.emplacement.id);
    },
    async getAllDemandeLogistiqueAsync(allDispositif) {
      let facesProduitIds = [];
      allDispositif.forEach(d => {
        d.materiels.filter(m => m.faces)
          .forEach(m => {
            facesProduitIds = facesProduitIds.concat(m.faces.map(f => f.produitId));
          });
      });

      const dateDebut = moment(this.dateSelect).startOf('week').toDate();
      const dateFin = moment(this.dateSelect).endOf('week').toDate();
      if (facesProduitIds.length !== 0) {
        const param = {
          query: {
            produitIds: facesProduitIds,
            societeId: this.societeActiveId,
            types: [INTERVENTION_TYPE_AFFICHAGE, INTERVENTION_TYPE_INTERVENTION],
            datePlanification: {
              dateDebut: formatDate(dateDebut),
              dateFin: formatDate(dateFin),
            },
          },
        };
        const result = (await getAllDemandeLogistique(param)).data.result.items;
        allDispositif.forEach(d => {
          d.materiels.filter(m => m.faces)
            .forEach(m => {
              m.faces.forEach(f => {
                const demandes = result.filter(d => d.produitId === f.produitId);
                if (demandes) {
                  f.demandesLogistique = demandes;
                }
              });
            });
        });
      }
      this.allDispositif = allDispositif;
    },
    gestionAffichageCreationDemande(type, item) {
      if (!this.checkPermissions(this.permDemande.maj)) {
        return false;
      }
      this.faceDemande = null;
      this.materielDemande = null;
      this.dispositifDemande = null;
      this.emplacementDemande = null;
      if (type === FACE) this.faceDemande = item;
      if (type === MATERIEL) this.materielDemande = item;
      if (type === DISPOSITIF) this.dispositifDemande = item;
      if (type === EMPLACEMENTS) this.emplacementDemande = item;
      return true;
    },
    affichageDemande(type, item) {
      if (this.gestionAffichageCreationDemande(type, item)) {
        this.showPopUpListeDemandes = true;
      }
    },
    createDemande(type, item) {
      if (this.gestionAffichageCreationDemande(type, item)) {
        this.showPopUpDemande = true;
      }
    },
    async checkUpdateProduitFace(face) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      this.titleError = null;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await checkUtilisationFaceAsync(face.id);
        this.setInfoFace({
          id: face.id,
          code: face.code,
          societeId: this.emplacement.societeId,
          agenceId: this.emplacement.agenceId,
          idEmplacement: this.$route.params.id,
        });
        loadingComponent.close();
        await this.$router.push({ name: 'm.gabed.emplacement-remplacementProduitFace' });
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationDeleteFace(e.response, this.messages);
          this.titleError = 'detailEmplacement.error.remlacementImpossible';
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async deleteFace(row) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      this.titleError = null;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteFace(row.id);
        messageSucces(this.$i18n.t('listeFace.messages.success.faceDeleted', { code: row.code }));
        await this.load();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationDeleteFace(e.response, this.messages);
          this.error = true;
          this.titleError = 'detailEmplacement.error.deleteImpossible';
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async load() {
      this.emplacement = (await get(this.$route.params.id)).data.result;
      const dataBody = {
        query: {
          emplacementId: this.$route.params.id,
          societeId: this.societeActiveId,
        },
        skipCount: 0,
        maxResultCount: 200,
      };
      const allDispositif = (await getAll(dataBody)).data.result.items;
      dispositifSort(allDispositif);
      allDispositif.forEach(dispo => {
        dispo.materiels.forEach(mat => {
          mat.informationsNumeriques = genererElementMaterielNumerique();
        });
      });
      await this.getAllDemandeLogistiqueAsync(allDispositif);
      if (this.$route.name === 'c.gabed.emplacement-detailEmplacement') {
        this.setInformationPage(this.$t('pageGeneral.detail', { item: this.emplacement.code }));
      }
      this.finChargement = true;
    },
    getLibellePuce(patrimoine) {
      let libelle = this.$i18n.t('detailEmplacement.archive');
      let couleur = COULEUR_ARCHIVE;
      couleur = this.getCouleur(patrimoine.etat);
      libelle = this.$i18n.t(this.allEtat.find((el) => {
        return el.value === patrimoine.etat;
      }).libelle);
      return { libelle, couleur };
    },
    getCouleur(etat) {
      let couleur;
      switch (etat) {
        case MONTE:
          couleur = COULEUR_MONTE;
          break;
        case DEMONTE:
          couleur = COULEUR_DEMONTE;
          break;
        case AMONTE:
        case ADEMONTE:
          couleur = COULEUR_AMONTER_ADEMONTER;
          break;
        case ENCOURSDEFABRICATION:
          couleur = COULEUR_ENCOURS_DE_FABRICATION;
          break;
        case FABRIQUE:
          couleur = COULEUR_FABRIQUE;
          break;
        default:
          couleur = COULEUR_ENCOURS_MONTAGE_DEMONTAGE;
          break;
      }
      return couleur;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.load();
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key]);
      loadingComponent.close();
    } catch (e) {
      this.finChargement = true;
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
